import React, { useEffect } from 'react';

import { navigate, withPage } from '@sms/plasma-ui';
import app from '../config/app.json';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
const SUB_PATH: string = (window as any).plasma?.environment?.SUB_PATH ?? '/';
const PROCESSED_SUB_PATH = SUB_PATH.replace(/\/$/, '');

const RootPage: React.FC = () => {
  useEffect(() => {
    setTimeout(() => navigate(`${PROCESSED_SUB_PATH}/${app.code}/books`), 100);
  }, []);

  return <></>;
};

export default withPage(RootPage);
